import { Component } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './i18n';
import './index.scss';
import 'photoswipe/dist/photoswipe.css';
import { store, persistor } from './reduxToolkit/store';
import { PersistGate } from 'redux-persist/integration/react';
interface Props {
  children: React.ReactNode;
}
unstable_batchedUpdates(() => {
  console.error = () => {};
});

class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: { message: string | string[] }) {
    if (error.message.includes('ToastContainer')) {
      return;
    }
  }
  render() {
    return this.props.children;
  }
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />{' '}
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
);
